(() => {
  window.solevureMenuCleanup?.();
  const lifecycle = new AbortController();
  let controller;
  let currentMenu;
  window.solevureMenuCleanup = () => {
    lifecycle.abort();
    controller?.abort();
  };
  const initialize = () => {
    const menu = document.getElementById('at-menu');
    if (menu === currentMenu) return;
    controller?.abort();
    currentMenu = menu;
    if (!menu) return;
    controller = new AbortController();
    const signal = controller.signal;
    let opener;
    const triggers = Array.from(document.querySelectorAll('[data-at-open="at-menu"],.at-nav-group>summary'));
    const updateTriggers = () => triggers.filter(button => button.matches('[data-at-open="at-menu"]')).forEach(button => button.setAttribute('aria-expanded', String(menu.open && (button === opener || button.matches('[data-at-open="at-menu"]')))));
    const panels = Array.from(menu.querySelectorAll('[data-sv-panel]'));
    const show = (id, backwards = false, focus = true) => {
      const target = panels.find(panel => panel.dataset.svPanel === String(id));
      if (!target) return;
      panels.forEach(panel => {
        panel.hidden = panel !== target;
        panel.classList.remove('sv-menu__incoming', 'sv-menu__returning');
      });
      target.scrollTop = 0;
      menu.querySelectorAll('[data-sv-enter]').forEach(button => button.setAttribute('aria-expanded', String(button.dataset.svEnter === String(id))));
      target.classList.add(backwards ? 'sv-menu__returning' : 'sv-menu__incoming');
      if (!backwards && id !== 'root') target.querySelectorAll('details[open]').forEach(details => details.open = false);
      if (focus) (backwards ? menu.querySelector(`[data-sv-enter="${menu.dataset.svCurrent}"]`) : target.querySelector('button,a'))?.focus({preventScroll:true});
      menu.dataset.svCurrent = String(id);
    };
    document.addEventListener('click', event => {
      const trigger = event.target.closest('[data-at-open="at-menu"],.at-nav-group>summary');
      if (!trigger) return;
      if (trigger.matches('.at-nav-group>summary') && matchMedia('(min-width: 1001px)').matches) return;
      opener = trigger;
      if (trigger.matches('.at-nav-group>summary')) {
        event.preventDefault();
        event.stopPropagation();
        document.querySelectorAll('.at-dialog[open]').forEach(dialog => dialog.close());
        menu.showModal();
        const groups = Array.from(trigger.closest('.at-nav').children);
        show(groups.indexOf(trigger.parentElement) + 1);
        updateTriggers();
      } else {
        show('root', false, false);
        requestAnimationFrame(updateTriggers);
      }
    }, {capture: true, signal});
    menu.addEventListener('click', event => {
      const enter = event.target.closest('[data-sv-enter]');
      if (enter) show(enter.dataset.svEnter);
      if (event.target.closest('[data-sv-back]')) show('root', true);
    }, {signal});
    menu.addEventListener('toggle', event => {
      if (!event.target.matches('.sv-menu__accordion') || !event.target.open) return;
      event.target.closest('ul').querySelectorAll('.sv-menu__accordion[open]').forEach(details => { if (details !== event.target) details.open = false; });
    }, {capture: true, signal});
    menu.addEventListener('close', () => {
      menu.querySelectorAll('details[open]').forEach(details => details.open = false);
      show('root', false, false);
      updateTriggers();
      if (!document.querySelector('.at-dialog[open]')) opener?.focus({preventScroll:true});
    }, {signal});
    menu.addEventListener('toggle', event => {
      if (event.target === menu) updateTriggers();
    }, {signal});
    triggers.filter(button => button.matches('[data-at-open="at-menu"]')).forEach(button => {
      button.setAttribute('aria-controls','at-menu');
      button.setAttribute('aria-haspopup','dialog');
      button.setAttribute('aria-expanded','false');
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initialize,{once: true, signal:lifecycle.signal});
  else initialize();
  document.addEventListener('shopify:section:load',initialize,{signal:lifecycle.signal});
  document.addEventListener('shopify:section:unload',event => {
    if (!currentMenu || !event.target.contains(currentMenu)) return;
    controller?.abort();
    currentMenu = undefined;
  },{signal:lifecycle.signal});
})();

